import router from "./router/index";

export default {
  router,
};
